<div class="complex-filter-empty">
  <strong>{{ searchTerm }}</strong> not found
</div>
